import { Navigate } from 'react-router-dom'
import TradePage from './TradePage'
import LimitOrder from './components/LimitOrder/LimitOrder'
import SwapTokens from './components/SwapTrade/SwapTokens'
import ReviewLimit from './components/LimitOrder/ReviewLimit'
import ReviewSwap from './components/SwapTrade/ReviewSwap'
import SwapSuccess from './components/SwapTrade/SwapSuccess'
import LimitSuccess from './components/LimitOrder/LimitSuccess'
import ProtectRouter from './ProtectRouter'
import Take from './components/Take'
import Invest from './components/SwapTrade/Invest'

export const tradeRoutes = {
  path: '/trade',
  name: 'Trade',
  element: <TradePage />,
  children: [
    { index: true, element: <Navigate to='swap' replace /> },
    {
      path: 'invest',
      element: <Invest />,
    },
    {
      path: 'swap',
      element: <SwapTokens />,
    },
    {
      path: 'limit',
      element: <LimitOrder />,
    },
    {
      path: 'limit/review',
      element: <ProtectRouter children={<ReviewLimit />} />,
    },
    {
      path: 'swap/review',
      element: <ProtectRouter children={<ReviewSwap />} />,
    },
    {
      path: 'invest/review',
      element: <ProtectRouter children={<ReviewSwap mode='Invest' />} />,
    },
    {
      path: 'limit/success',
      element: <ProtectRouter children={<LimitSuccess />} />,
    },
    {
      path: 'swap/success',
      element: (
        <ProtectRouter
          children={<SwapSuccess header='Swap successfully executed' />}
        />
      ),
    },
    {
      path: 'invest/success',
      element: (
        <ProtectRouter
          children={<SwapSuccess header='Investion successfully executed' />}
        />
      ),
    },
    {
      path: 'take',
      element: <ProtectRouter children={<Take />} />,
    },
    {
      path: 'take/success',
      element: (
        <ProtectRouter
          children={<SwapSuccess header='Offer successfully taken' />}
        />
      ),
    },
  ],
}
